import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import AntTable from "../../AntTable/AntTable";

import { useQuery } from "@tanstack/react-query";
import { getPackagesAdmin } from "../../../network/admin";
import AvatarGroupTable from "../common/AvatarGroupTable";
import PopoverServicesIncluded from "../common/PopoverServicesIncluded";
type Props = {
  isFilter: any;
  selectedRowKeys: any;
  setSelectedRowKeys: any;
  searchHeader: any;
};

const TabPackage = ({
  isFilter,
  selectedRowKeys,
  setSelectedRowKeys,
  searchHeader,
}: Props) => {
  const statusColor = (status: string) => {
    switch (status) {
      case "active":
      case "Active":
        return "#479821";
      case "blocked":
      case "Blocked":
        return "#B0B0C0";
      case "pending":
      case "Pending":
        return "#CF953D";
      default:
        return "#B0B0C0"; // Default color if status doesn't match any case
    }
  };
  const [page, setPage] = useState<number>(1);
  const { data, isLoading } = useQuery(
    ["package", isFilter, searchHeader],
    () => getPackagesAdmin({ page, ...isFilter, search: searchHeader })
  );
  console.log(data?.data?.services, "servicesservicesservicesservices");

  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Package name</div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary">
          {record?.name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon{" "}
        </div>
      ),
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="text-sm font-medium text-color-primary" dir="ltr">
          {record?.location?.name}
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Services</div>,
      dataIndex: "display_all_booking",

      render: (text: any, record) => <PopoverServicesIncluded data={record} />,
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Team Members</div>
      ),
      dataIndex: "team",
      render: (text: any, record) => <AvatarGroupTable data={record} />,
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Package time</div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className="text-[#9999A7] flex items-center gap-1">
          <span className="text-sm font-medium text-color-primary">
            {record?.total_time}
          </span>
          <span className="text-color-primary w-fit text-[8px] mt-1">mins</span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Service gender</div>
      ),
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={`text-[${statusColor(
            record?.status
          )}] text-sm font-medium flex items-center w-full justify-between`}
        >
          <span className="w-full text-color-primary">
            {record?.available_for}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Service price</div>
      ),
      dataIndex: "price",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className={`text-sm font-semibold flex items-center gap-1 w-full`}>
          <span className="text-color-primary w-fit">
            {record?.retail_price}
          </span>
          <span className="text-color-primary w-fit text-[8px] mt-1">SR</span>
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer">
          <AiOutlineEdit className="text-[#75757E]" />
        </div>
      ),
    },
  ];

  return (
    <div>
      <AntTable
        tableColumns={columns}
        tableData={data?.data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        isLoading={isLoading}
        expandRowByClick={false}
        // hideArrowExpand
        selectionType={selectedRowKeys}
        setPage={setPage}
        page={page}
        total={data?.meta?.total}
      />
    </div>
  );
};

export default TabPackage;
